import type { Client } from '../../../api/client.js';

/** Suppléments en un clic (PARITE-5, RG-25) : routes `facturation.supplements.*` du contrat seulement. */
export interface ArticleCatalogue {
  code: string;
  label: string;
  unitAmountCents: number | null;
}

export interface Supplement {
  id: string;
  dossierId: string;
  code: string;
  label: string;
  unitAmountCents: number;
  quantity: number;
  totalCents: number;
  billable: boolean;
  note: string | null;
  createdAt: string;
  createdByDisplayName: string;
  invoiced: boolean;
  rowVersion: number;
}

export interface SupplementsDuDossier {
  catalogue: ArticleCatalogue[];
  catalogueStatus: 'a_valider' | 'valide';
  supplements: Supplement[];
  billableTotalCents: number;
  notBilledTotalCents: number;
  fraisReelsActive: boolean;
}

export interface NouveauSupplement {
  code: string;
  unitAmountCents?: number;
  quantity: number;
  billable: boolean;
  note?: string;
}

export interface SourceSupplements {
  lister(): Promise<SupplementsDuDossier>;
  ajouter(s: NouveauSupplement): Promise<Supplement>;
  retirer(id: string): Promise<void>;
}

export const PERMISSION_ECRIRE_SUPPLEMENTS = 'billing:write:dossier';

export function creerSourceSupplements(client: Client, dossierId: string): SourceSupplements {
  return {
    lister: () => client.appeler<SupplementsDuDossier>('facturation.supplements.lister', { parametres: { dossierId } }),
    ajouter: (s) => client.appeler<Supplement>('facturation.supplements.ajouter', { parametres: { dossierId }, corps: s }),
    retirer: async (id) => {
      await client.appeler('facturation.supplements.retirer', { parametres: { supplementId: id } });
    },
  };
}
